module.exports = __webpack_public_path__ + "img/A3z-i.d67d6a99.jpg";